'use strict';

require("moduleFold/notifiche/scripts/index.js");
require("moduleFold/datasource/scripts/index.js");
require("moduleFold/validatori/scripts/index.js");
var BssBasicField = require("moduleFold/formbuilder/scripts/mixins/BssBasicField");


/**
 * Campo di tipo entity su entity esterna
 * 
 * @class  
 * @param {type} formlyConfig
 * @param {type} formlyValidationMessages
 * @param {Valida} Valida
 */
function BSSLaum(formlyConfig, formlyValidationMessages, Valida){
    formlyConfig.setType($.extend(true, {}, new BssBasicField(), {
        name: 'bsslaum', 
        extends: 'bssselect',
        template: require("./bsslaum.html"), //"src/bsslib/formbuilder/scripts/campi/localita/bsslocalita.html",
        controller: ["$scope", "$rootScope", "$filter", "$timeout", "$http", "$sce", "$state", "ErrorManager", "DSFactory", "FieldFactory", "Valida", require("./BssLaumController")],
        defaultOptions: {
            ngModelElAttrs: {
                'cssCategory': 'bsslaum'
            },
        }
    }));
}

module.exports = BSSLaum;